import { render } from "./index.vue?vue&type=template&id=0da070df&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0da070df&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=0da070df&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da070df"],['__file',"src/views/Legalize/Formulario/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0da070df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0da070df', __exports__)) {
    console.log('reload')
    api.reload('0da070df', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=0da070df&scoped=true", () => {
    console.log('re-render')
    api.rerender('0da070df', render)
  })

}


export default __exports__